export enum Genders{
    M = 'Masculino',
    F = 'Feminino',
    A = 'Ambos',
}

export const getDescricaoByCodigoGender = (codigo: string)=>{
    const values: string[] = Object.values(Genders)
    const keys: string[] = Object.keys(Genders)

    const index = keys.indexOf(codigo)
    return values[index]
}

export const getCodigoByDescricaoGender = (desc: string)=>{
    const values: string[] = Object.values(Genders)
    const keys: string[] = Object.keys(Genders)

    const index = values.indexOf(desc)
    return keys[index]
}